var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:( _obj = {
    'red--text': _vm.value < 0
  }, _obj[("bg-" + (Math.ceil(Math.min(_vm.value, 1) * 10)))] = true, _obj )},[_vm._v(" "+_vm._s(_vm._f("percent")(_vm.value,1))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }